import React from 'react';
import didgitalSkills from '../assets/images/digitalliteracy.jpeg';
import enterprenurship from '../assets/images/Enterprenurship.jpeg';
import softSkill from '../assets/images/softSkill.jpeg';
import StarIcon from '@mui/icons-material/Star';

const FundamentalSkills = () => {
  return (
    <div className='w-full h-auto pt-[80px] pt-[32px] text-start text-[16px] leading-[24px] flex justify-center items-center flex-wrap gap-[25px]'>
      <h1 className='text-[#041a45] w-full text-[48px] leading-[57.6px] text-left mx-[80px] my-[18px] lg:text-center'>
        Build fundational skills for tech roles
      </h1>
      {/*  */}
      <div className='text-[16px] leading-[24px] flex justify-center w-[348px]  h-[auto] bg-[#041a45] rounded-[16px] px-[16px] pb-[16px] flex-wrap gap-[2px] mb-[34px]'>
        <div className='w-[316px] h-[497px] px-[16px] pt-[32px] flex justify-center items-center flex-col'>
          <div className='w-[284px] h-[64px] text-[17px] font-bold leading-[26.4px] text-left px-[16px] py-[6px] mb-[32px] rounded-[16px] bg-[#000000] text-white'>
            Digital literacy and productivity
          </div>
          <p href='#!' className='w-[308px] h-[180px] mb-4'>
            <img
              className='rounded-[16px] w-full h-full '
              src={didgitalSkills}
              alt='missing picture'
            />
          </p>
          {/*  */}
          <div className='w-[284px] h-[186px] leading-[24px] text-center text-[16px]'>
            <h1 className='text-white text-[25.6px] leading-[38.4px] text-left font-bold mb-2'>
              3 courses- 4 hours
            </h1>
            <p className='w-[284px] h-[131px] text-white text-[17.6px] leading-[26.4px] mb-[6px] text-left'>
              Learn the fundamentals of using operating systems, applications,
              and productivity tools to collaborate with others and explore the
              web.
            </p>
          </div>
          {/*  */}
        </div>

        <div className='w-[316px] h-[419px] px-[16px] pb-[16px] text-[16px] text-center leading-[24px]  flex justify-center items-center flex-col'>
          <div className='w-[284px] my-[20px] text-[21px] leading-[24px] text-center flex justify-start items-center h-auto font-bold text-[#ffffff] text-left'>
            What you’ll learn:
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Collaborate and connect using online productivity tools.
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Learn to use the internet safely and responsibly.
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Working with Computers and Devices.
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Fundamentals of Word, Excel, OneNote, Outlook, and PowerPoint.
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[284px] h-[85px] mt-[25px] mb-[54px]'>
          <a
            href='https://wootlabacademy.com/#/'
            className='w-[284px] h-[53px] py-[12px] px-[56px] bg-[#ffbd39] rounded-[100px] shadow-[rgba(0, 0, 0, 0.2) 0px 2px 2px 0px] text-white font-bold text-[17.6px] leading-[26.4px] text-center capitalize hover:bg-black hover:cursor-pointer hover:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out'
          >
            Get Started
          </a>
        </div>
      </div>
      {/*  */}
      <div className='text-[16px] leading-[24px] flex justify-center w-[348px] h-[auto] bg-[#041a45] rounded-[16px] px-[16px] pb-[16px] flex-wrap gap-[2px] mb-[34px]'>
        <div className='w-[316px] h-[497px] px-[16px] pt-[32px] flex justify-center items-center flex-col'>
          <div className='w-[284px] h-[64px] text-[17px] font-bold leading-[26.4px] text-left px-[16px] py-[6px] mb-[32px] rounded-[16px] bg-[#000000] text-white'>
            Soft skill
          </div>
          <p href='#!' className='w-[308px] h-[180px] mb-4'>
            <img
              className='rounded-[16px] w-full h-full '
              src={softSkill}
              alt='missing picture'
            />
          </p>
          {/*  */}
          <div className='w-[284px] h-[186px] leading-[24px] text-center text-[16px]'>
            <h1 className='text-white text-[25.6px] leading-[38.4px] text-left font-bold mb-2'>
              12 courses- 10 hours
            </h1>
            <p className='w-[284px] h-[131px] text-white text-[17.6px] leading-[26.4px] mb-[6px] text-left'>
              Enhance your employability with these essential skills: emotional
              intelligence and critical thinking to unconscious bias and
              teamwork.
            </p>
          </div>
          {/*  */}
        </div>

        <div className='w-[316px] h-[419px] px-[16px] pb-[16px] text-[16px] text-center leading-[24px]  flex justify-center items-center flex-col'>
          <div className='w-[284px] my-[20px] text-[21px] leading-[24px] text-center flex justify-start items-center h-auto font-bold text-[#ffffff] text-left'>
            What you’ll learn:
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Creative thinking and teamwork skills
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Leadership and negotiation skills
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              People and soft skills
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Emotional intelligence
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[284px] h-[85px] mt-[25px] mb-[54px]'>
          <a
            href='https://wootlabacademy.com/#/'
            className='w-[284px] h-[53px] py-[12px] px-[56px] bg-[#ffbd39] rounded-[100px] shadow-[rgba(0, 0, 0, 0.2) 0px 2px 2px 0px] text-white font-bold text-[17.6px] leading-[26.4px] text-center capitalize hover:bg-black hover:cursor-pointer hover:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out'
          >
            Get Started
          </a>
        </div>
      </div>
      {/*  */}
      <div className='text-[16px] leading-[24px] flex justify-center w-[348px] h-[auto] bg-[#041a45] rounded-[16px] px-[16px] pb-[16px] flex-wrap gap-[2px] mb-[34px]'>
        <div className='w-[316px] h-[497px] px-[16px] pt-[32px] flex justify-center items-center flex-col'>
          <div className='w-[284px] h-[64px] text-[17px] font-bold leading-[26.4px] text-left px-[16px] py-[6px] mb-[32px] rounded-[16px] bg-[#000000] text-white'>
            Entrepreneurship
          </div>
          <p href='#!' className='w-[308px] h-[180px] mb-4'>
            <img
              className='rounded-[16px] w-full h-full '
              src={enterprenurship}
              alt='missing picture'
            />
          </p>
          {/*  */}
          <div className='w-[284px] h-[186px] leading-[24px] text-center text-[16px]'>
            <h1 className='text-white text-[25.6px] leading-[38.4px] text-left font-bold mb-2'>
              8 courses- 10 hours
            </h1>
            <p className='w-[284px] h-[131px] text-white text-[17.6px] leading-[26.4px] mb-[6px] text-left'>
              Learn decision making techniques and problem-solving skills
              necessary to succeed as a small business owner from developing
              your business idea to raising capital.
            </p>
          </div>
          {/*  */}
        </div>

        <div className='w-[316px] h-[419px] px-[16px] pb-[16px] text-[16px] text-center leading-[24px]  flex justify-center items-center flex-col'>
          <div className='w-[284px] my-[20px] text-[21px] leading-[24px] text-center flex justify-start items-center h-auto font-bold text-[#ffffff] text-left'>
            What you’ll learn:
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Entrepreneurship strategy
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Developing a business plan
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Sourcing startup capital
            </p>
          </div>
          <div className='w-[284px] mb-[16px] text-[16px] leading-[24px] text-center flex justify-center items-top gap-[9px]  h-auto text-[#ffffff]'>
            <StarIcon fontSize='small' color='white' className='' />
            <p className='w-[284px] h-[52px] text-[17.6px] leading-[26.px] text-left text-[#ffffff] '>
              Marketing your small business
            </p>
          </div>
        </div>
        {/*  */}
        <div className='w-[284px] h-[85px] mt-[25px] mb-[54px]'>
          <a
            href='https://wootlabacademy.com/#/'
            className='w-[284px] h-[53px] py-[12px] px-[56px] bg-[#ffbd39] rounded-[100px] shadow-[rgba(0, 0, 0, 0.2) 0px 2px 2px 0px] text-white font-bold text-[17.6px] leading-[26.4px] text-center capitalize hover:bg-black hover:cursor-pointer hover:shadow-lg focus:outline-none focus:ring-0 active:shadow-lg transition duration-150 ease-in-out'
          >
            Get Started
          </a>
        </div>
      </div>
    </div>
  );
};

export default FundamentalSkills;
